/**
 * Breadcrumbs allowing path navigation.
 */

import React from 'react';

import * as S from './ArtifactFilePath.styles';

type ArtifactFilePathProps = {
  selected: any; // node
  onSelect: (path: string) => void;
};

export const ArtifactFilePath = ({
  selected,
  onSelect,
}: ArtifactFilePathProps) => {
  const parts = ['', ...selected.path];
  const items = parts.reduce((result, item, i) => {
    const path = '/' + parts.slice(1, i + 1).join('/');
    result.push(
      <S.PathSegment key={2 * i} onClick={() => onSelect(path)}>
        {item ? item : 'Root'}
      </S.PathSegment>
    );
    if (i < selected.path.length) {
      result.push(<span key={2 * i + 1}>&nbsp;&gt;&nbsp;</span>);
    }
    return result;
  }, []);

  return <div>{items}</div>;
};
